<template>
  <div class="footer-info">
    <nav>
      <ul class="footer-links">
        <li v-if="!isLogged" class="link">
          <cv-link target="_blank" :href="userGuideLoginTroubleshootUrl" :tabindex="tabIndex">
            {{ t("footer_link_login_troubleshoot") }}
          </cv-link>
        </li>
        <li v-else class="link">
          <cv-link to="/helpdesk" :tabindex="tabIndex">{{ t("footer_link_helpdesk") }}</cv-link>
        </li>
        <li v-if="isLogged" class="link">
          <cv-link target="_blank" :href="userGuideUrl" :tabindex="tabIndex">
            {{ t("footer_link_user_guide") }}
          </cv-link>
        </li>
        <li class="link">
          <cv-link to="/terms-of-use" :tabindex="tabIndex">{{
            t("footer_link_terms_of_use")
          }}</cv-link>
        </li>
        <li class="link">
          <cv-link to="/privacy-statement" :tabindex="tabIndex">{{
            t("footer_link_privacy_statement")
          }}</cv-link>
        </li>
        <li class="link">
          <cv-link target="_blank" :href="reportVulnerabilityUrl" :tabindex="tabIndex">
            {{ t("footer_link_report_vulnerablity") }}
          </cv-link>
        </li>
        <li class="link">
          <cv-link target="_blank" :href="slsInfoSiteUrl" :tabindex="tabIndex">
            {{ t("footer_link_sls_info_site") }}
          </cv-link>
        </li>
      </ul>
    </nav>
    <p class="copyright">{{ t("app_copyright", { year: year }) }}</p>
  </div>
</template>

<script setup lang="ts">
import appConfigs from "@configs/app";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

interface Props {
  disableKeyboardNav?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  disableKeyboardNav: false,
});

const { t } = useI18n();

const year = ref<number>(new Date().getFullYear());
const userGuideLoginTroubleshootUrl = ref<string>(appConfigs.userGuideLoginTroubleshootUrl);
const reportVulnerabilityUrl = ref<string>(appConfigs.reportVulnerabilityUrl);
const slsInfoSiteUrl = ref<string>(appConfigs.userGuideUrl);

const store = useStore();

const isLogged = computed<boolean>(() => !!store.getters["auth/isLogged"]);
const isStudent = computed<boolean>(() => !!store.getters["auth/isStudent"]);
const isTeacher = computed<boolean>(() => !!store.getters["auth/isTeacher"]);

const userGuideUrl = computed<string>(() => {
  if (isTeacher.value) return appConfigs.teacherUserGuideUrl;
  if (isStudent.value) return appConfigs.studentUserGuideUrl;
  return appConfigs.userGuideUrl;
});

const tabIndex = computed<number>(() => (props.disableKeyboardNav ? -1 : 0));
</script>
